import { gql } from '@apollo/client'

export const CLONE_SCHEMA = gql`
  mutation CloneSchema($schemaId: ID!, $environmentSlug: String) {
    cloneSchema(schemaId: $schemaId, environmentSlug: $environmentSlug) {
      id
    }
  }
`
